import {NgModule} from "@angular/core";
import { Routes, RouterModule } from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {CustomFormsModule} from 'ng2-validation';
import {DirectivesModule} from './../../directives/directives.module';
import { ComponentsModule } from './../../components/components.module';
import { registerLocaleData, CommonModule } from '@angular/common';
import {MatExpansionModule} from '@angular/material/expansion';
import localePt from '@angular/common/locales/pt';
import { CalculadorasMainPageComponent } from './new-calculadoras-page/calculadoras-main-page.component';
import { ResultadoPopUpComponent } from './resultado-pop-up/resultado-pop-up.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatTableModule } from '@angular/material/table';

const routes: Routes = [
    {path: '', component: CalculadorasMainPageComponent},
    {path: ':id', component: CalculadorasMainPageComponent}
];

registerLocaleData(localePt, 'pt-BR');

@NgModule({
    declarations: [
        CalculadorasMainPageComponent,
        ResultadoPopUpComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        CustomFormsModule,
        RouterModule.forChild(routes),
        DirectivesModule,
        ComponentsModule,
        HighchartsChartModule,
        MatExpansionModule,
        MatTableModule
    ],
    exports: []
})
export class CalculadorasModule {

}